import BaseApi from '../BaseApi';
import {
  IThirdPartyCustomerSearchParams,
  ITicketLocation,
  ITicketQueryParams,
  TTicketBranch
} from 'models/SupportTicket';

const buildQueryString = (params: ITicketQueryParams | IThirdPartyCustomerSearchParams): string => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;

    if (Array.isArray(value)) {
      value.forEach(item => {
        if (item === undefined || item === null || item === '') return;
        search.append(key, String(item));
      });
      return;
    }

    search.append(key, String(value));
  });
  const queryStr = search.toString();
  return queryStr ? `?${queryStr}` : '';
};

const SupportTicketApi = {
  // --- Nhóm / Loại hỗ trợ ---
  StaffAssignTag: (data: { branchs: TTicketBranch[]; tagIds: number[]; staffUserName?: string }) => {
    return BaseApi.POST('api/SupportTicket/StaffAssignTag', data);
  },
  GetAssignedTag: (staffUserName?: string) => {
    return BaseApi.GET(`api/SupportTicket/GetAssignedTag${staffUserName ? `?staffUserName=${staffUserName}` : ''}`);
  },
  GetStuctureTag: () => {
    return BaseApi.GET('api/SupportTicket/GetStuctureTag');
  },
  CreateTag: (data: {
    name: string;
    description?: string;
    index?: number;
    categories: { name: string; description?: string; defaultPriority?: number; index?: number }[];
  }) => {
    return BaseApi.POST('api/SupportTicket/CreateTag', data);
  },
  AddCategories: (data: {
    tagId: number;
    categories: { name: string; description?: string; defaultPriority?: number; index?: number }[];
  }) => {
    return BaseApi.POST('api/SupportTicket/AddCategories', data);
  },
  UpdateTag: (data: { id: number; name: string; description?: string; isDisable?: boolean; index?: number }) => {
    return BaseApi.PUT('api/SupportTicket/UpdateTag', data);
  },
  UpdateCategory: (data: {
    id: number;
    name: string;
    description?: string;
    defaultPriority?: number;
    index?: number;
    isDisable?: boolean;
  }) => {
    return BaseApi.PUT('api/SupportTicket/UpdateCategory', data);
  },

  // --- Phiếu hỗ trợ ---
  // _t = thời điểm gọi: URL mỗi lần một khác để trình duyệt không trả kết quả cũ từ cache.
  // Vd bấm "Xem" ở tab Lịch sử với cùng khoảng ngày + bộ lọc -> cùng URL GET -> không có request mới (phải đổi ngày
  // mới thấy gọi API). Backend bỏ qua tham số lạ trên query string.
  GetForInner: (query: ITicketQueryParams) => {
    return BaseApi.GET(`api/SupportTicket/GetForInner${buildQueryString({ ...query, _t: Date.now() } as any)}`);
  },
  GetByIdForInner: (id: number) => {
    return BaseApi.GET(`api/SupportTicket/GetByIdForInner?id=${id}&_t=${Date.now()}`);
  },
  Receive: (id: number) => {
    return BaseApi.PUT(`api/SupportTicket/Receive/${id}`, {});
  },
  UpdateTicketByStaff: (data: {
    id: number;
    resolveContent?: string;
    priority?: number;
    targetDate?: string;
    location?: ITicketLocation;
    // Sửa thông tin phiếu (backend bổ sung 15/10/2026). name = tên khách (model đọc về là customerName)
    categoryIds?: number[];
    name?: string;
    contactNumber?: string;
    vehiclePlates?: string[];
    /** Chỉ nhận khi phiếu do CSKH tạo và không có customerUserName */
    systemBranch?: string;
  }) => {
    return BaseApi.PUT('api/SupportTicket/UpdateTicketByStaff', data);
  },
  AttachOrder: (data: { supportTicketId: number; orderCode: string; note?: string }) => {
    return BaseApi.PUT('api/SupportTicket/AttachOrder', data);
  },
  Complete: (data: { supportTicketId: number; note?: string }) => {
    return BaseApi.PUT('api/SupportTicket/Complete', data);
  },
  Pending: (data: { supportTicketId: number; targetDate: string; note?: string }) => {
    return BaseApi.PUT('api/SupportTicket/Pending', data);
  },
  Continue: (data: { supportTicketId: number; note?: string }) => {
    return BaseApi.PUT('api/SupportTicket/Continue', data);
  },
  NoteAfterComplete: (data: { supportTicketId: number; note: string }) => {
    return BaseApi.PUT('api/SupportTicket/NoteAfterComplete', data);
  },
  UploadFileByStaff: (formData: FormData) => {
    return BaseApi.POST('api/SupportTicket/UploadFileByStaff', formData);
  },
  // multipart: SupportTicketId, ResolveContent, Files[] (tệp gắn vào nội dung xử lý)
  AddResolveContentByStaff: (formData: FormData) => {
    return BaseApi.POST('api/SupportTicket/AddResolveContentByStaff', formData);
  },
  // multipart: SupportTicketId, ResolveContentId, ResolveContent, RetainedFileIds[], NewFiles[]
  UpdateResolveContentByStaff: (formData: FormData) => {
    return BaseApi.PUT('api/SupportTicket/UpdateResolveContentByStaff', formData);
  },

  CreateTicketBySaff: (formData: FormData) => {
    return BaseApi.POST('api/SupportTicket/CreateByStaff', formData);
  },

  // huỷ phiếu do nhân viên tạo
  // {
  //   "supportTicketId": 7,	// Id của phiếu hỗ trợ
  //   "note": "Cancel test"	// Lý do được ghi vào timeline
  // }

  CancelFromStaff: (data: { supportTicketId: number; note: string }) => {
    return BaseApi.PUT('api/SupportTicket/CancelFromStaff', data);
  },

  // thêm vào object SupportTicketApi
  SearchThirdPartyCustomer: (query: IThirdPartyCustomerSearchParams) => {
    return BaseApi.GET(`api/ThirdPartyCustomer/Search${buildQueryString(query)}`);
  }
};

export default SupportTicketApi;
